import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError } from '@src/helpers/toastError'
import { PayloadCreatorParams } from '@src/redux/types'
import { omit } from 'ramda'

import * as api from '../api'
import { CHAT_MESSAGE_ALL, CHAT_MESSAGE_LIST, CHAT_MESSAGE_POST } from '../constants/actionTypes'
import * as API from '../constants/api'

export const chatMessageAll = createAsyncThunk(
  CHAT_MESSAGE_ALL,
  async (params: PayloadCreatorParams<`${typeof API.CHAT_MESSAGE_ALL}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.chatMessageAll(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const chatMessageList = createAsyncThunk(
  CHAT_MESSAGE_LIST,
  async (params: PayloadCreatorParams<`${typeof API.CHAT_MESSAGE}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.chatMessageList(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const chatMessagePost = createAsyncThunk(
  CHAT_MESSAGE_POST,
  async (params: PayloadCreatorParams<`${typeof API.CHAT_MESSAGE}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.chatMessagePost(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const chatMessageAllClear = createAction(`${CHAT_MESSAGE_ALL}/clear`)

export const chatMessageListClear = createAction(`${CHAT_MESSAGE_LIST}/clear`)
